export default __webpack_public_path__ + "static/media/man6.5bee2dc2.JPG";